import React, { useState, useEffect } from "react"
import { useLocation, useHistory } from "react-router"
import styles from "../css/home/collections.module.css"
import furnature from "../images/productImages/group/lgroup1.jpg"
import lights from "../images/productImages/lightsms/cluster.jpg"
import stackabl from "../images/productImages/lightssl/AC_4.jpg"

export default function LightCollections(props) {
    const history = useHistory()
    return (
        <div className={styles.collections}>
            <div
                className={styles.cat + " " + styles.tall}
                onClick={() => {
                    history.push("/lightcollectionsl")
                }}
            >
                <img src={stackabl} />
                <label>STACKABL Arcilla Collection</label>
            </div>
            <div
                className={styles.cat + " " + styles.tall}
                onClick={() => {
                    history.push("/lightcollectionms")
                }}
            >
                <img src={lights} />
                <label>STACKABL x Mindy Solomon </label>
            </div>
            <div
                className={styles.cat + " " + styles.tall}
                onClick={() => {
                    history.push("/lightcollection")
                }}
            >
                <img src={furnature} />
                <label>STACKABL x Maison Gerard</label>
            </div>
        </div>
    )
}
